<template>
  <header class="grad-nav" role="banner">
    <div class="container">
      <div class="d-md-flex justify-content-between align-items-center" :class="headerClass">
        <ul class="list-inline">
          <li class="list-inline-item">
            <h1 class="text-center pt-2 pb-1">
              <a v-if="$route.name !== 'Recognition' && $route.name !== 'Recognition' && $route.name !== 'Innovation Always On Site'" href="/#/" title="Home" rel="home">Think<span>Tank</span></a>
              <a v-else href="/#/" title="Home" rel="home"><img src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/11/logo.png" />            </a>
            </h1>
          </li>
          <li class="list-inline-item text-white" v-if="$route.name === 'Recognition' || $route.name === 'Recognition'|| $route.name === 'Innovation Always On Site'">
            <h6>MULTICHOICE GROUP<br><span class="small">EMPLOYEE RECOGNITION</span></h6>
          </li>
        </ul>
        <h5 v-if="$route.name !== 'Login' && $route.name !== 'Login with return' && $route.name !== 'Recognition' && $route.name !== 'Recognition' && $route.name !== 'Innovation Always On Site'" class="site-description d-none d-lg-block">innovate<span>//</span>collaborate<span>//</span>relate</h5>
        <div v-if="$route.name !== 'Login' && $route.name !== 'Login with return'" id="search">
          <form role="search" method="get" id="searchform" v-on:submit.prevent="">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search" value="" name="s" id="s" v-model="searchQuery">
              <div class="input-group-append">
                <button type="submit" class="btn btn-primary" id="searchsubmit" v-on:click="searchForContent()">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
        <b-dropdown v-if="$route.name !== 'Login' && $route.name !== 'Login with return'" id="ddown-right" right>
          <template slot="button-content">
            <i class="fas fa-user fa-sm fa-fw"></i> Hello {{username}}
          </template>
          <b-dropdown-item class="text-left" to="/my-profile"><i class="fas fa-user fa-fw fa-sm"></i> My Profile/My Ideas</b-dropdown-item>
          <b-dropdown-item class="text-left" :to="editPath"><i class="fas fa-user fa-fw fa-sm"></i> Edit My Details</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item class="text-left" to="/all-ideas"><i class="fas fa-users fa-fw fa-sm"></i> ThinkTank - All Ideas</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item-button class="text-left" v-on:click="signOut()"><i class="fas fa-sign-out-alt fa-fw fa-sm"></i> Sign out</b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
// import bDropdown from 'bootstrap-vue/esm/components/dropdown/dropdown'
import {BDropdown, BDropdownItem, BDropdownItemButton} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    'b-dropdown': BDropdown,
    'b-dropdown-item': BDropdownItem,
    'b-dropdown-item-button': BDropdownItemButton
  },
  data () {
    return {
      username: '',
      editPath: '',
      searchQuery: '',
      headerClass: ''
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUserName'
    ])
  },
  created () {
    this.$store.dispatch('userDetails')
      .then(response => {
        this.username = this.getUserName
        this.editPath = '/my-profile/edit-my-details'
      })
      .catch(error => {
        console.log('header message', error)
        this.username = error
        //console.log('index of Val-> ', this.username.toLowerCase().indexOf('error: user not found'))
        // if (this.username.toLowerCase().indexOf('user not found') !== -1 || this.username === 'Error: User not found')
        this.$router.push('/login')
      })
    if (this.$route.name === 'Login') {
      this.headerClass = 'titleCenter'
    } else {
      this.headerClass = ''
    }
  },
  methods: {
    searchForContent: function () {
      this.$router.push('/search/' + this.searchQuery)
    },
    signOut: function () {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  },
  watch: {
    getUserName (newDetails, oldDetails) {
      if (newDetails !== 'not set') {
        this.username = this.getUserName
      }
    },
    '$route' (to, from) {
      if (this.$route.name === 'Login') {
        this.headerClass = 'titleCenter'
      } else {
        this.headerClass = ''
      }
    }
  }
}
</script>

<style lang="less">
  #ddown-right__BV_toggle_ {
    background: none;
    border: none;
  }
  .titleCenter {
    justify-content: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/SiteHeader.vue